import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '../views/HomePage';
import LoginPage from '../views/LoginPage';
import AllBlogsPage from "@/views/AllBlogsPage";
import AboutPage from "@/views/AboutPage";
import ContactPage from "@/views/ContactPage";
import AdminDashboard from "@/views/AdminDashboard";
import store from '@/store/store';
import BlogDetailPage from "@/views/BlogDetailPage";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WriteBlog from "@/views/WriteBlog";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'HomePage',
            component: HomePage,
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/login',
            name: 'LoginPage',
            component: LoginPage,
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/blog',
            name: 'AllBlogsPage',
            component: AllBlogsPage,
            meta: {
                requiresAuth: false,
            }
        },
        {
            path: '/blog/:id',
            name: 'BlogDetailPage',
            components: {
                default: BlogDetailPage,
                header: Header,
                footer: Footer
            },
            props: { default: true, type: String, header: true, footer: true, },
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/about',
            name: 'AboutPage',
            component: AboutPage,
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/contact',
            name: 'ContactPage',
            component: ContactPage,
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/dashboard',
            name: 'AdminDashboard',
            component: AdminDashboard,
            meta: {
                requiresAuth: true,
                requiresSuperAdmin: true
            },
        },
        {
            path: '/write',
            name: 'WriteBlog',
            component: WriteBlog,
            meta: {
                requiresAuth: false,
                requiresSuperAdmin: false
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    console.log("beforeEach called");
    console.log(to.meta.requiresAuth);
    if(to.meta.requiresAuth) {
        console.log(store.getters.isAuthenticated);
        if (!(store.getters.isAuthenticated)) {
            next('/');
        } else {
            console.log(store.getters.isSuperAdmin);
            if (to.meta.requiresSuperAdmin) {
                if (!store.getters.isSuperAdmin) {
                    next('/blog');
                } else {
                    next();
                }
            } else {
                next();
            }
        }
    } else {
        next();
    }
});

export default router;
